import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function TableContainer({ children, className }) {
    return (_jsx("div", { className: cn('overflow-y-auto rounded-3xl bg-neutral-50 p-6 flex flex-col gap-4 h-fit max-h-full', className), children: children }));
}
